var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./LeadGenerationForm.module.scss";
import { Button, Form } from "react-bootstrap";
import { getSettings, getTranslation } from "../../constants/setting";
import chatBotApi from "../../api/chatbot";
import { setCategories, setIsLeadGenerationSubmitted, setLanguage, setSessionId, setLeadGenerationData } from "../../stores/reducers/chatReducer";
import LoadingChatBotResponse from "../LoadingChatBotResponse/LoadingChatBotResponse";
import { getTextColor } from "../../helper";
import { useDispatch } from "react-redux";
var LeadGenerationForm = function () {
    var dispatch = useDispatch();
    var primary_color = getSettings().primary_color;
    var _b = useState({}), errors = _b[0], setErrors = _b[1];
    var _j = useState(false), isLoading = _j[0], setIsLoading = _j[1];
    var prepareSubmit = function (e) {
        e.preventDefault();
        setIsLoading(function (prevState) { return !prevState; });
        setErrors({});
        // @ts-ignore
        var formData = Object.fromEntries(new FormData(e.target));
        chatBotApi.startSession(formData).then(function (response) {
            dispatch(setLeadGenerationData(formData));
            dispatch(setIsLeadGenerationSubmitted(true));
            dispatch(setLanguage(getSettings().language));
            dispatch(setSessionId(response.data.session_id || ''));
            dispatch(setCategories(response.data.categories || []));
        }).catch(function (err) {
            if (err.response.data.error.code === 400) {
                setErrors(err.response.data.error.messages);
            }
            else {
                console.error(err);
                console.log(err);
            }
        }).finally(function () {
            setIsLoading(function (prevState) { return !prevState; });
        });
    };
    return _jsx("div", __assign({ className: styles.leadGenerationFormWrapper }, { children: _jsxs("div", __assign({ className: styles.leadGenerationForm }, { children: [_jsx("p", __assign({ className: styles.leadGenerationFormDesc }, { children: _jsx("strong", { dangerouslySetInnerHTML: { __html: getTranslation('chatbot.lead_generation_form_description') || '' } }) })), _jsxs(Form, __assign({ onSubmit: prepareSubmit }, { children: [_jsxs("div", __assign({ className: styles.fieldGroup }, { children: [_jsxs("div", __assign({ className: styles.fieldHolder }, { children: [_jsx(Form.Control, { required: true, placeholder: getTranslation('chatbot.first_name'), name: "first_name", type: "text", className: styles.field + (errors.first_name ? ' is-invalid' : '') }), errors.first_name && _jsx("span", __assign({ className: "d-block text-danger mb-1" }, { children: errors.first_name[0] }))] })), _jsxs("div", __assign({ className: styles.fieldHolder }, { children: [_jsx(Form.Control, { required: true, placeholder: getTranslation('chatbot.last_name'), name: "last_name", type: "text", className: styles.field + (errors.last_name ? ' is-invalid' : '') }), errors.last_name && _jsx("span", __assign({ className: "d-block text-danger mb-1" }, { children: errors.last_name[0] }))] }))] })), _jsx(Form.Control, { required: true, placeholder: getTranslation('chatbot.email'), name: "email", type: "text", className: styles.field + (errors.email ? ' is-invalid' : '') }), errors.email && _jsx("span", __assign({ className: "d-block text-danger mb-1" }, { children: errors.email[0] })), isLoading ? _jsx(LoadingChatBotResponse, {}) :
                            _jsx(Button, __assign({ className: styles.sendButton, type: "submit", variant: "primary", id: "send_inquiry", style: {
                                    backgroundColor: primary_color,
                                    borderColor: primary_color,
                                    color: getTextColor(primary_color)
                                } }, { children: getTranslation('chatbot.submit') }))] }))] })) }));
};
export default LeadGenerationForm;
